export default "__VITE_ASSET__Cxpimg3q__"